import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Spacer } from './Spacer';
import { Typography } from './Typography';
import { QuoteFragment } from '../types/graphqlTypes';

const StyledBlockquote = styled.blockquote`
  ${({ theme: { space, media, layers } }) => css`
    position: relative;
    padding-top: ${space.lg};

    > * {
      position: relative;
    }

    &:before {
      content: '';
      display: block;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 75'%3E%3Cpath fill='%23E5E5E5' d='M94.424 0C80.61 7.208 75.271 15.356 71.504 21.624c-8.478 13.79-13.816 35.726-2.827 47.008a18.407 18.407 0 0 0 26.061 0c7.222-7.207 6.908-18.803-.314-26.01-3.768-3.448-8.163-4.702-12.245-5.329-5.338-.94-6.908-19.743 14.13-34.786L94.423 0ZM31.627 0C18.126 7.208 12.788 15.356 9.02 21.624.543 35.414-4.795 57.35 6.194 68.632a18.407 18.407 0 0 0 26.061 0c7.222-7.207 6.908-18.803-.314-26.01-3.768-3.448-8.163-4.702-12.56-5.329-5.023-.94-6.593-19.743 14.444-34.786L31.627 0Z'/%3E%3C/svg%3E");
      height: 75px;
      width: 100px;
      position: absolute;
      left: -${space.md};
      top: 0;
    }

    @media (min-width: ${media.lg}) {
      &:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 144 107'%3E%3Cpath fill='%23E5E5E5' d='M135.144.816c-19.712 10.304-27.328 21.952-32.704 30.912-12.096 19.712-19.712 51.072-4.032 67.2a26.228 26.228 0 0 0 37.184 0c10.304-10.304 9.856-26.88-.448-37.184-5.376-4.928-11.648-6.72-17.472-7.616-7.616-1.344-9.856-28.224 20.16-49.728L135.144.816Zm-89.6 0C26.28 11.12 18.664 22.768 13.288 31.728 1.192 51.44-6.424 82.8 9.256 98.928a26.228 26.228 0 0 0 37.184 0c10.304-10.304 9.856-26.88-.448-37.184-5.376-4.928-11.648-6.72-17.92-7.616C20.904 52.784 18.664 25.904 48.68 4.4L45.544.816Z'/%3E%3C/svg%3E");
        height: 106px;
        width: 143px;
      }
    }
  `};
`;

export const Quote: FC<Omit<QuoteFragment, '__typename'>> = ({ quoteText, quoteName, position, company }) => (
  <Spacer as="figure">
    <StyledBlockquote>
      <Typography variant="displaySmall" component="p">
        {quoteText}
      </Typography>
    </StyledBlockquote>
    <figcaption>
      {quoteName && (
        <>
          <Typography variant="titleSmall" component="span">
            {quoteName}
          </Typography>
          <br />
        </>
      )}
      {position && (
        <>
          {position}
          <br />
        </>
      )}
      {company && <>{company}</>}
    </figcaption>
  </Spacer>
);
